module.exports = __webpack_public_path__ + "img/star.0288763e.gif";